import React, { useState } from 'react';
import { useLocationSearch } from '../../hooks/useLocationSearch';
import Spinner from './spinner/Spinner';

const LocationSelect = ({
    selectedLocation,
    setSelectedLocation,
    className = '',
    borderColor = '',
    onBlur,
    name
}) => {
    const { query, setQuery, locations, isLoading } = useLocationSearch({
        initialQuery: selectedLocation.id ? selectedLocation.name : ''
    });
    const [showLocations, setShowLocations] = useState(false);

    const handleLocationChange = selectedLocation => {
        setSelectedLocation(selectedLocation || {});
        setQuery(selectedLocation.name);
        setShowLocations(false);
    };

    return (
        <>
            <div className='relative'>
                <input
                    onChange={event => {
                        setQuery(event.target.value || '');
                        setShowLocations(true);
                    }}
                    onBlur={onBlur}
                    name={name}
                    className={`px-4 appearance-none text-[14px] bg-transparent border-b-2 ${borderColor || 'border-gray-600'} w-full text-[#000000] py-4 leading-[24px] focus:outline-none`}
                    type='text'
                    value={query}
                    aria-label='location'
                    placeholder='Start typing...'
                />
                {selectedLocation.id && (
                    <button
                        type='button'
                        onClick={() => {
                            setSelectedLocation({});
                            setQuery('');
                        }}
                        className='absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-gray-100 rounded-full transition-colors bg-transparent'
                        aria-label='Clear selection'
                    >
                        <svg
                            width='20'
                            height='20'
                            viewBox='0 0 20 20'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M15 5L5 15M5 5L15 15'
                                stroke='currentColor'
                                strokeWidth='2'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                            />
                        </svg>
                    </button>
                )}
            </div>
            {showLocations && (
                <div
                    className={`absolute z-50 overflow-y-scroll text-[12px] max-h-[35vh] mt-1 bg-white w-full flex flex-col gap-5 rounded-xl ${className} px-4 shadow-2xl`}
                >
                    {isLoading ? (
                        <Spinner />
                    ) : (
                        <ul className=''>
                            {locations.map(location => (
                                <li
                                    onClick={() =>
                                        handleLocationChange(location)
                                    }
                                    key={location.id}
                                    className='pb-7 border-b-[2px] border-gray-200 flex my-7'
                                >
                                    <p className='text-[14px] font-[400] leading-[24px] font-poppins text-center'>
                                        {location.name}
                                    </p>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            )}
        </>
    );
};

export default React.memo(LocationSelect);
